import { Component } from '@angular/core';

@Component({
  selector: 'pdf-find-previous',
  templateUrl: './pdf-find-previous.component.html',
  styleUrls: ['./pdf-find-previous.component.css'],
})
export class PdfFindPreviousComponent {}
